import styled from "styled-components";
import { FormLabel, InputGroup } from "@chakra-ui/react";

export const Container = styled.div`
  --grid-size: auto / auto auto auto;
  --grid-gap: 100px;

  display: grid;
  //padding: 20px;
  grid: var(--grid-size);
  grid-gap: var(--grid-gap);
  justify-content: center;

  @media screen and (max-width: 1070px) {
    --grid-gap: 50px;
  }

  @media screen and (max-width: 1240px) {
    --grid-gap: 40px;
  }

  @media screen and (max-width: 850px) {
    --grid-gap: 20px;
  }

  @media screen and (max-width: 710px) {
    --grid-size: auto / auto auto;
    --grid-gap: 30px;
  }

  @media screen and (max-width: 470px) {
    --grid-size: auto / auto;
  }
`;

export const Pesquisa = styled.div`
  display: flex;
  width: 100%;
  margin-top: 2.1875rem;

  padding-left: 70px;
  padding-right: 70px;
  justify-content: center;

  .input-pesquisa {
    width: 500px;
  }

  .bnt-cadastro {
    background-color: #3f3d56;
    color: #ffffff;
    border-radius: 0.4375rem;
  }

  @media screen and (max-width: 730px) {
    flex-direction: column;
    align-items: center;
    max-width: 100vw;
    .input-select {
      margin-right: 0;
    }
    .input-pesquisa {
      width: 210px;
    }

    .bnt-cadastro {
      width: 210px;
      height: 35px;
      margin-right: 20px;
    }
  }
`;

export const StyledInputGroup = styled(InputGroup)`
  display: flex;

  @media screen and (max-width: 530px) {
    flex-direction: column;
   
    .input-file {
      width: 500px;
    }
  }
`;

